// "FBO" card of a ShareJet booking: departure and arrival FBO.
import type { ReactNode } from 'react';
import { Card, Descriptions } from 'antd';

import type { AdminBookingDetail } from '../../api/types';
import { FboView } from '../../components/FboView';

export function FboCard({ b, extra }: { b: AdminBookingDetail; extra: ReactNode }) {
  return (
    <Card title="FBO" extra={extra}>
      <Descriptions column={{ xs: 1, sm: 2 }} bordered size="small">
        <Descriptions.Item label="Departure FBO">
          <FboView f={b.departureFbo} />
        </Descriptions.Item>
        <Descriptions.Item label="Arrival FBO">
          <FboView f={b.arrivalFbo} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
